<div class="library-header">
  <span class="title">
    <img [src]="'/svg/chat-library.svg' | assetVersion" alt="Chat Library" />
    Chat library</span>
  <button class="close-button" (click)="onClose()">
    <img [src]="'/svg/closeX-grey.svg' | assetVersion" alt="Close"/>
  </button>
</div>
